import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ExternalLink, Award, Star, ShieldAlert, CreditCard, Building2, Globe, FileText, Video, Calendar, ChevronLeft, ChevronRight, Check } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function ExportCarsPage() {
  const navigate = useNavigate();
  const { language, t } = useLanguage();

  const [googleIndex, setGoogleIndex] = useState(0);
  const [mobileIndex, setMobileIndex] = useState(0);

  const googleReviews = {
    da: [
      {
        author: "Joan Nielsen",
        rating: 5,
        text: '"Virkelig god oplevelse. Rigtig god og kompetent hjælp fra start til slut. Kan varmt anbefales at bruge dette firma."',
        date: "Maj 2025",
        initials: "JN",
        color: "bg-blue-600"
      },
      {
        author: "Christian Sohl",
        rating: 5,
        text: '"Rigtig fin oplevelse i forbindelse med salg af bil. God kommunikation og hurtig betaling efter aftale. Afhentning efter betaling. Kan anbefales."',
        date: "April 2025",
        initials: "CS",
        color: "bg-emerald-600"
      },
      {
        author: "Peter Halling Bruun",
        rating: 5,
        text: '"Sami Kobeita er en meget flink og troværdig mand, og jeg kan kun sige positive ting. Alt gik helt efter bogen, og jeg købte en meget velholdt bil. Sami får mine varmeste anbefalinger!"',
        date: "Marts 2025",
        initials: "PB",
        color: "bg-amber-600"
      },
      {
        author: "Ionut Tavi",
        rating: 5,
        text: '"Jeg havde en fremragende oplevelse! Kommunikationen var klar og hurtig under hele processen. Betalingen var problemfri, og de hjalp endda med at læsse bilen. Varm anbefaling!"',
        date: "Oktober 2024",
        initials: "IT",
        color: "bg-purple-600"
      },
      {
        author: "Be4aR",
        rating: 5,
        text: '"Alt gik glat, lige fra kommunikation til betaling, og til sidst hjalp de mig med at læsse bilen. Jeg anbefaler denne forhandler."',
        date: "Oktober 2024",
        initials: "B",
        color: "bg-rose-600"
      },
      {
        author: "Matilde Kvist",
        rating: 5,
        text: '"Stor hjælp ved salg af bil, sød, venlig og ærlig."',
        date: "Oktober 2024",
        initials: "MK",
        color: "bg-teal-600"
      }
    ],
    en: [
      {
        author: "Joan Nielsen",
        rating: 5,
        text: '"Really great experience. Very good and competent help from start to finish. Highly recommend using this company."',
        date: "May 2025",
        initials: "JN",
        color: "bg-blue-600"
      },
      {
        author: "Christian Sohl",
        rating: 5,
        text: '"Really nice experience in connection with selling my car. Good communication and fast payment as agreed. Pickup after payment. Highly recommended."',
        date: "April 2025",
        initials: "CS",
        color: "bg-emerald-600"
      },
      {
        author: "Peter Halling Bruun",
        rating: 5,
        text: '"Sami Kobeita is a very nice and trustworthy man, and I can only report positive things. Everything went exactly by the book and I bought a very well-maintained car. Sami gets my warmest recommendations!"',
        date: "March 2025",
        initials: "PB",
        color: "bg-amber-600"
      },
      {
        author: "Ionut Tavi",
        rating: 5,
        text: '"I had an excellent experience! Communication was clear and prompt throughout. Payment was hassle-free, and they even helped me load the car. Highly recommend!"',
        date: "October 2024",
        initials: "IT",
        color: "bg-purple-600"
      },
      {
        author: "Be4aR",
        rating: 5,
        text: '"Everything went smooth, from communication to payment, and at the end they helped me with loading the car. I recommend this seller."',
        date: "October 2024",
        initials: "B",
        color: "bg-rose-600"
      },
      {
        author: "Matilde Kvist",
        rating: 5,
        text: '"Great help when selling my car, sweet, friendly and honest."',
        date: "October 2024",
        initials: "MK",
        color: "bg-teal-600"
      }
    ],
    de: [
      {
        author: "Joan Nielsen",
        rating: 5,
        text: '"Wirklich tolle Erfahrung. Sehr gute und kompetente Hilfe von Anfang bis Ende. Kann dieses Unternehmen wärmstens empfehlen."',
        date: "Mai 2025",
        initials: "JN",
        color: "bg-blue-600"
      },
      {
        author: "Christian Sohl",
        rating: 5,
        text: '"Sehr schöne Erfahrung im Zusammenhang mit dem Verkauf meines Autos. Gute Kommunikation und schnelle Zahlung wie vereinbart. Abholung nach Zahlung. Sehr zu empfehlen."',
        date: "April 2025",
        initials: "CS",
        color: "bg-emerald-600"
      },
      {
        author: "Peter Halling Bruun",
        rating: 5,
        text: '"Sami Kobeita ist einen sehr netter und vertrauenswürdiger Mann, und ich kan nur Positives berichten. Alles lief genau nach Vorschrift und ich habe ein sehr gepflegtes Auto gekauft. Sami bekommt meine wärmsten Empfehlungen!"',
        date: "März 2025",
        initials: "PB",
        color: "bg-amber-600"
      },
      {
        author: "Ionut Tavi",
        rating: 5,
        text: '"Ich hatte eine hervorragende Erfahrung! Die Kommunikation war während des gesamten Prozesses klar und prompt. Die Bezahlung war problemlos, und sie halfen sogar beim Beladen des Autos. Sehr zu empfehlen!"',
        date: "Oktober 2024",
        initials: "IT",
        color: "bg-purple-600"
      },
      {
        author: "Be4aR",
        rating: 5,
        text: '"Alles lief reibungslos, von der Kommunikation bis zur Bezahlung, und am Ende halfen sie mir beim Beladen des Autos. Ich empfehle diesen Händler."',
        date: "Oktober 2024",
        initials: "B",
        color: "bg-rose-600"
      },
      {
        author: "Matilde Kvist",
        rating: 5,
        text: '"Große Hilfe beim Verkauf meines Autos, süß, freundlich und ehrlich."',
        date: "Oktober 2024",
        initials: "MK",
        color: "bg-teal-600"
      }
    ]
  };

  const mobileReviews = {
    da: [
      {
        author: "Auto-Zentrum GmbH",
        rating: 5,
        text: '"Meget professionel partner til B2B-eksport. Kommunikationen var hurtig og pålidelig. Alle dokumenter (CMR, Gelangensbestätigung) var perfekt forberedt. Gerne igen!"',
        date: "April 2025",
        initials: "AZ",
        color: "bg-indigo-600"
      },
      {
        author: "Mihai Dumitrescu",
        rating: 5,
        text: '"Jeg har købt flere biler af Sami. Fremragende service, meget ærlig beskrivelse af bilerne og stor hjælp med eksportplader. Kan varmt anbefales til internationale forhandlere!"',
        date: "Marts 2025",
        initials: "MD",
        color: "bg-orange-600"
      },
      {
        author: "Klaus Weber - KW Automobile",
        rating: 5,
        text: '"Meget pålidelig forhandler. Hurtig ekspedition, bil som beskrevet. Alle eksportdokumenter var klar ved afhentning. Absolut anbefalelsesværdig."',
        date: "Februar 2025",
        initials: "KW",
        color: "bg-cyan-600"
      },
      {
        author: "SIA Baltics Cars",
        rating: 5,
        text: '"Perfekt B2B-handel. Hurtigt svar, gennemsigtig proces og meget hjælpsom med læsning. Vi vil helt sikkert købe fra Vejle AutoExport igen."',
        date: "Januar 2025",
        initials: "SB",
        color: "bg-violet-600"
      },
      {
        author: "Andrzej Kowalski",
        rating: 5,
        text: '"Handlen forløb perfekt. Rigtig god kontakt, hjælp til læsning og eksportformaliteter. Kan anbefales!"',
        date: "November 2024",
        initials: "AK",
        color: "bg-emerald-600"
      }
    ],
    en: [
      {
        author: "Auto-Zentrum GmbH",
        rating: 5,
        text: '"Very professional partner for B2B export. Communication was fast and reliable. All documents (CMR, Gelangensbestätigung) were perfectly prepared. Gladly again!"',
        date: "April 2025",
        initials: "AZ",
        color: "bg-indigo-600"
      },
      {
        author: "Mihai Dumitrescu",
        rating: 5,
        text: '"I bought several cars from Sami. Excellent service, very honest description of the vehicles, and great help with transit plates. Highly recommended for international dealers!"',
        date: "March 2025",
        initials: "MD",
        color: "bg-orange-600"
      },
      {
        author: "Klaus Weber - KW Automobile",
        rating: 5,
        text: '"Very reliable dealer. Fast processing, car as described. All export documents were ready upon pickup. Highly recommended."',
        date: "February 2025",
        initials: "KW",
        color: "bg-cyan-600"
      },
      {
        author: "SIA Baltics Cars",
        rating: 5,
        text: '"Perfect B2B transaction. Fast response, transparent process, and very helpful with loading. We will definitely buy from Vejle AutoExport again."',
        date: "January 2025",
        initials: "SB",
        color: "bg-violet-600"
      },
      {
        author: "Andrzej Kowalski",
        rating: 5,
        text: '"Transaction went smoothly. Very good contact, help with loading and export formalities. Recommended!"',
        date: "November 2024",
        initials: "AK",
        color: "bg-emerald-600"
      }
    ],
    de: [
      {
        author: "Auto-Zentrum GmbH",
        rating: 5,
        text: '"Sehr professioneller Partner für den B2B-Export. Die Kommunikation war schnell und zuverlässig. Alle Dokumente (CMR, Gelangensbestätigung) wurden perfekt vorbereitet. Gerne wieder!"',
        date: "April 2025",
        initials: "AZ",
        color: "bg-indigo-600"
      },
      {
        author: "Mihai Dumitrescu",
        rating: 5,
        text: '"Ich habe mehrere Autos von Sami gekauft. Hervorragender Service, sehr ehrliche Beschreibung der Fahrzeuge und tolle Unterstützung bei den Exportkennzeichen. Sehr empfehlenswert für internationale Händler!"',
        date: "März 2025",
        initials: "MD",
        color: "bg-orange-600"
      },
      {
        author: "Klaus Weber - KW Automobile",
        rating: 5,
        text: '"Sehr zuverlässiger Händler. Schnelle Abwicklung, Auto wie beschrieben. Alle Exportdokumente lagen bei Abholung bereit. Absolut empfehlenswert."',
        date: "Februar 2025",
        initials: "KW",
        color: "bg-cyan-600"
      },
      {
        author: "SIA Baltics Cars",
        rating: 5,
        text: '"Perfekte B2B-Transaktion. Schnelle Antwort, transparenter Prozess und sehr hilfreich beim Beladen. Wir werden auf jeden Fall wieder bei Vejle AutoExport kaufen."',
        date: "Januar 2025",
        initials: "SB",
        color: "bg-violet-600"
      },
      {
        author: "Andrzej Kowalski",
        rating: 5,
        text: '"Transaktion verlief reibungslos. Sehr guter Kontakt, Hilfe beim Beladen und bei den Exportformalitäten. Empfehlenswert!"',
        date: "November 2024",
        initials: "AK",
        color: "bg-emerald-600"
      }
    ]
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-44 md:pt-52 pb-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Section 1: Vejle Auto Export – Your Trusted Partner for Export Cars */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start mb-24">
          {/* Left Column: Text Content */}
          <div className="lg:col-span-7 space-y-6">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-black italic text-[#293e30] tracking-tight leading-tight uppercase mb-6">
              {t('export.title')}
            </h1>
            
            <p className="text-lg text-slate-700 leading-relaxed font-medium">
              {t('export.desc')}
            </p>
            
            <p className="text-slate-600 leading-relaxed">
              {t('export.p2')}
            </p>
            
            <p className="text-slate-600 leading-relaxed">
              {t('export.p3')}
            </p>

            {/* Explore our range of export cars for sale today! */}
            <div className="pt-4">
              <p className="text-slate-900 font-bold uppercase text-sm tracking-wider mb-4">
                {t('export.cta_explore')}
              </p>
              <div className="flex flex-wrap gap-4">
                <a
                  href="https://home.mobile.de/VEJLEAUTOEXPORT#ses"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3.5 bg-[#76eeda] hover:bg-[#5cdbc7] text-black font-bold text-xs tracking-wider uppercase rounded-none transition-all cursor-pointer"
                >
                  <span>{t('export.cta_sale')}</span>
                  <ArrowRight className="h-4 w-4" />
                </a>
                <a
                  href="https://www.mobile.de/bewertungen/VEJLEAUTOEXPORT?lang=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-6 py-3.5 border border-slate-300 hover:border-slate-900 text-slate-900 font-bold text-xs tracking-wider uppercase rounded-none transition-all cursor-pointer bg-white"
                >
                  <span>{t('export.cta_mobile')}</span>
                  <ExternalLink className="h-4 w-4" />
                </a>
              </div>
            </div>
          </div>

          {/* Right Column: Premium Image */}
          <div className="lg:col-span-5">
            <div className="relative w-full h-[450px] shadow-2xl border border-slate-200 overflow-hidden">
              <iframe
                title="Google Maps - Vejle AutoExport v/ Sami Kobeita"
                src="https://maps.google.com/maps?q=Vejle%20AutoExport%20v/%20Sami%20Kobeita,%20Storgaden%2097,%206052%20Viuf&t=k&z=18&ie=UTF8&iwloc=&output=embed"
                className="w-full h-full border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* Section 2: Reputable Car Dealership */}
        <div className="bg-slate-50 p-8 md:p-12 rounded-none border border-slate-100 mb-24">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-6">
              {t('export.sec2_title')}
            </h2>
            <p className="text-slate-600 leading-relaxed">
              {t('export.sec2_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
            <div className="space-y-4">
              <p className="text-slate-600 leading-relaxed">
                {t('export.sec2_p1')}
              </p>
              <p className="text-slate-600 leading-relaxed">
                {t('export.sec2_p2')}
              </p>
            </div>

            <div className="space-y-4">
              <p className="text-slate-600 leading-relaxed">
                {t('export.sec2_p3')}
              </p>
              <p className="text-slate-600 leading-relaxed">
                {t('export.sec2_p4')}
              </p>
            </div>
          </div>
        </div>

        {/* Section: B2B Export Terms & Payment Sales Terms */}
        <div className="mb-24">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-4">
              {t('export.terms_title')}
            </h2>
            <p className="text-slate-600 leading-relaxed">
              {t('export.terms_subtitle')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Card 1: B2B Export Terms */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-red-50 text-red-600 rounded-none">
                    <ShieldAlert className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_b2b_title')}
                  </h3>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">
                  {t('export.terms_b2b_text')}
                </p>
              </div>
            </div>

            {/* Card 2: Payment & Reservation */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-emerald-50 text-emerald-600 rounded-none">
                    <CreditCard className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_payment_title')}
                  </h3>
                </div>
                <ul className="space-y-3 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <span className="text-red-500 font-bold shrink-0">⛔</span>
                    <span>{t('export.terms_payment_b1')}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-emerald-500 font-bold shrink-0">✓</span>
                    <span>{t('export.terms_payment_b2')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card 3: EU Commercial Dealers */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-blue-50 text-blue-600 rounded-none">
                    <Building2 className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_eu_title')}
                  </h3>
                </div>
                <p className="text-xs font-bold uppercase text-slate-400 tracking-wider mb-2">
                  {t('export.terms_eu_subtitle')}
                </p>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <span className="text-blue-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_eu_b1')}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-blue-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_eu_b2')}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-emerald-500 font-bold shrink-0">✓</span>
                    <span>{t('export.terms_eu_b3')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card 4: Non-EU Export */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-amber-50 text-amber-600 rounded-none">
                    <Globe className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_noneu_title')}
                  </h3>
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <span className="text-amber-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_noneu_b1')}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-amber-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_noneu_b2')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card 5: Netto Cars Documentation */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-indigo-50 text-indigo-600 rounded-none">
                    <FileText className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_netto_title')}
                  </h3>
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <span className="text-indigo-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_netto_b1')}</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-indigo-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_netto_b2')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card 6: Brutto Cars Documentation */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-purple-50 text-purple-600 rounded-none">
                    <Video className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_brutto_title')}
                  </h3>
                </div>
                <ul className="space-y-2 text-sm text-slate-600">
                  <li className="flex items-start gap-2">
                    <span className="text-purple-500 font-bold shrink-0">•</span>
                    <span>{t('export.terms_brutto_b1')}</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Card 7: Export Plates & Insurance */}
            <div className="bg-white p-6 border border-slate-100 shadow-md flex flex-col justify-between hover:shadow-lg transition-shadow md:col-span-2 lg:col-span-3">
              <div>
                <div className="flex items-center gap-3 mb-4">
                  <div className="p-2.5 bg-teal-50 text-teal-600 rounded-none">
                    <Calendar className="h-6 w-6" />
                  </div>
                  <h3 className="font-black italic text-lg text-slate-900 uppercase tracking-wider">
                    {t('export.terms_plates_title')}
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-slate-600">
                  <div className="flex items-start gap-2">
                    <span className="text-teal-500 font-bold shrink-0">✓</span>
                    <span>{t('export.terms_plates_b1')}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-teal-500 font-bold shrink-0">✓</span>
                    <span>{t('export.terms_plates_b2')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section: Reviews (Google & Mobile.de) */}
        <div className="mb-24">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <h2 className="text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-4">
              {t('export.reviews_title')}
            </h2>
            <p className="text-slate-600 leading-relaxed">
              {t('export.reviews_desc')}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">
            {/* Google Reviews Card */}
            <div className="bg-white p-8 border border-slate-100 shadow-xl shadow-slate-100/50 flex flex-col justify-between relative group">
              <div>
                {/* Card Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    {/* Google Icon/Logo */}
                    <svg className="h-8 w-8" viewBox="0 0 24 24">
                      <path
                        fill="#4285F4"
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                      />
                      <path
                        fill="#34A853"
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                      />
                      <path
                        fill="#FBBC05"
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z"
                      />
                      <path
                        fill="#EA4335"
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z"
                      />
                    </svg>
                    <div>
                      <span className="font-black italic text-lg text-slate-900 uppercase tracking-wider block leading-none">Google</span>
                      <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider">Verified Reviews</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 text-[#f6bb06]">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-current" />
                    ))}
                  </div>
                </div>

                {/* Overall Rating Stats */}
                <div className="mb-6 flex items-center justify-between bg-slate-50 p-4 border border-slate-100">
                  <div>
                    <div className="flex items-baseline gap-2 mb-0.5">
                      <span className="text-3xl font-extrabold text-slate-900">4.6</span>
                      <span className="text-xs text-slate-400 font-bold uppercase tracking-wider">/ 5.0</span>
                    </div>
                    <p className="text-xs font-bold text-slate-800">{t('export.google_rating')}</p>
                  </div>
                  
                  {/* Carousel Controls */}
                  <div className="flex items-center gap-1.5">
                    <button
                      onClick={() => setGoogleIndex((prev) => (prev - 1 + (googleReviews[language] || googleReviews['en']).length) % (googleReviews[language] || googleReviews['en']).length)}
                      className="p-1.5 bg-white border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 transition-all cursor-pointer"
                      aria-label="Previous review"
                    >
                      <ChevronLeft className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => setGoogleIndex((prev) => (prev + 1) % (googleReviews[language] || googleReviews['en']).length)}
                      className="p-1.5 bg-white border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 transition-all cursor-pointer"
                      aria-label="Next review"
                    >
                      <ChevronRight className="h-4 w-4" />
                    </button>
                  </div>
                </div>

                {/* Single Review Carousel Slide */}
                <div className="relative min-h-[180px] mb-6 flex flex-col justify-between">
                  {(() => {
                    const reviewsList = googleReviews[language] || googleReviews['en'] || [];
                    const review = reviewsList[googleIndex] || reviewsList[0];
                    if (!review) return null;
                    return (
                      <div className="p-5 bg-white border border-slate-100 shadow-sm transition-all duration-300">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-3">
                            <div className={`h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${review.color || 'bg-slate-500'}`}>
                              {review.initials}
                            </div>
                            <div>
                              <div className="flex items-center gap-1.5">
                                <span className="font-bold text-sm text-slate-900">{review.author}</span>
                                <span className="inline-flex items-center justify-center h-4 w-4 rounded-full bg-emerald-50 text-emerald-600" title="Verified Google Review">
                                  <Check className="h-2.5 w-2.5 stroke-[3]" />
                                </span>
                              </div>
                              <span className="text-[10px] text-slate-400 font-medium">{review.date}</span>
                            </div>
                          </div>
                          <div className="flex gap-0.5 text-[#f6bb06]">
                            {[...Array(review.rating)].map((_, i) => (
                              <Star key={i} className="h-3.5 w-3.5 fill-current" />
                            ))}
                          </div>
                        </div>
                        <p className="text-xs text-slate-600 italic leading-relaxed">
                          {review.text}
                        </p>
                      </div>
                    );
                  })()}
                  
                  {/* Dots Indicator */}
                  <div className="flex justify-center gap-1.5 mt-4">
                    {(googleReviews[language] || googleReviews['en']).map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setGoogleIndex(idx)}
                        className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${idx === googleIndex ? 'w-4 bg-slate-900' : 'w-1.5 bg-slate-200 hover:bg-slate-400'}`}
                        aria-label={`Go to review slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <a
                href="https://share.google/wJibOo0BfYOKr2Ngp"
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => {
                  e.preventDefault();
                  window.open("https://share.google/wJibOo0BfYOKr2Ngp", "_blank", "noopener,noreferrer");
                }}
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs tracking-wider uppercase rounded-none transition-all cursor-pointer text-center"
              >
                <span>{t('export.google_cta')}</span>
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>

            {/* Mobile.de Reviews Card */}
            <div className="bg-white p-8 border border-slate-100 shadow-xl shadow-slate-100/50 flex flex-col justify-between relative group">
              <div>
                {/* Card Header */}
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    {/* Mobile.de Logo */}
                    <img 
                      src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/cb143fdd-e310-48ce-a5b3-5c77249054d9.svg" 
                      alt="Mobile.de" 
                      className="h-6 object-contain"
                    />
                  </div>
                  <div className="flex items-center gap-1 text-[#f6bb06]">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 fill-current" />
                    ))}
                  </div>
                </div>

                {/* Overall Rating Stats */}
                <div className="mb-6 flex items-center justify-between bg-slate-50 p-4 border border-slate-100">
                  <div>
                    <div className="flex items-baseline gap-2 mb-0.5">
                      <span className="text-3xl font-extrabold text-slate-900">4.9</span>
                      <span className="text-xs text-slate-400 font-bold uppercase tracking-wider">/ 5.0</span>
                    </div>
                    <p className="text-xs font-bold text-slate-800">{t('export.mobile_rating')}</p>
                  </div>
                  
                  {/* Carousel Controls */}
                  <div className="flex items-center gap-1.5">
                    <button
                      onClick={() => setMobileIndex((prev) => (prev - 1 + (mobileReviews[language] || mobileReviews['en']).length) % (mobileReviews[language] || mobileReviews['en']).length)}
                      className="p-1.5 bg-white border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 transition-all cursor-pointer"
                      aria-label="Previous review"
                    >
                      <ChevronLeft className="h-4 w-4" />
                    </button>
                    <button
                      onClick={() => setMobileIndex((prev) => (prev + 1) % (mobileReviews[language] || mobileReviews['en']).length)}
                      className="p-1.5 bg-white border border-slate-200 hover:border-slate-900 text-slate-700 hover:text-slate-900 transition-all cursor-pointer"
                      aria-label="Next review"
                    >
                      <ChevronRight className="h-4 w-4" />
                    </button>
                  </div>
                </div>

                {/* Single Review Carousel Slide */}
                <div className="relative min-h-[180px] mb-6 flex flex-col justify-between">
                  {(() => {
                    const reviewsList = mobileReviews[language] || mobileReviews['en'] || [];
                    const review = reviewsList[mobileIndex] || reviewsList[0];
                    if (!review) return null;
                    return (
                      <div className="p-5 bg-white border border-slate-100 shadow-sm transition-all duration-300">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center gap-3">
                            <div className={`h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm ${review.color || 'bg-slate-500'}`}>
                              {review.initials}
                            </div>
                            <div>
                              <div className="flex items-center gap-1.5">
                                <span className="font-bold text-sm text-slate-900">{review.author}</span>
                                <span className="inline-flex items-center justify-center h-4 w-4 rounded-full bg-emerald-50 text-emerald-600" title="Verified Mobile.de Review">
                                  <Check className="h-2.5 w-2.5 stroke-[3]" />
                                </span>
                              </div>
                              <span className="text-[10px] text-slate-400 font-medium">{review.date}</span>
                            </div>
                          </div>
                          <div className="flex gap-0.5 text-[#f6bb06]">
                            {[...Array(review.rating)].map((_, i) => (
                              <Star key={i} className="h-3.5 w-3.5 fill-current" />
                            ))}
                          </div>
                        </div>
                        <p className="text-xs text-slate-600 italic leading-relaxed">
                          {review.text}
                        </p>
                      </div>
                    );
                  })()}
                  
                  {/* Dots Indicator */}
                  <div className="flex justify-center gap-1.5 mt-4">
                    {(mobileReviews[language] || mobileReviews['en']).map((_, idx) => (
                      <button
                        key={idx}
                        onClick={() => setMobileIndex(idx)}
                        className={`h-1.5 rounded-full transition-all duration-300 cursor-pointer ${idx === mobileIndex ? 'w-4 bg-slate-900' : 'w-1.5 bg-slate-200 hover:bg-slate-400'}`}
                        aria-label={`Go to review slide ${idx + 1}`}
                      />
                    ))}
                  </div>
                </div>
              </div>

              <a
                href="https://www.mobile.de/bewertungen/VEJLEAUTOEXPORT?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-slate-300 hover:border-slate-900 text-slate-900 font-bold text-xs tracking-wider uppercase rounded-none transition-all cursor-pointer bg-white text-center"
              >
                <span>{t('export.mobile_cta')}</span>
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Section 3: KONTAKT OS */}
        <div className="text-center max-w-2xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-black italic text-[#293e30] uppercase tracking-tight mb-6">
            {t('export.sec3_title')}
          </h3>
          <p className="text-slate-600 mb-8">
            {t('export.sec3_desc')}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/kontakt')}
              className="px-8 py-4 bg-[#76eeda] hover:bg-[#5cdbc7] text-black font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer"
            >
              {t('export.sec3_cta_contact')}
            </button>
            <button
              onClick={() => navigate('/', { state: { scrollTo: 'vurdering-form' } })}
              className="px-8 py-4 border border-slate-200 hover:border-slate-900 text-slate-900 font-bold text-sm tracking-wider uppercase rounded-none transition-all cursor-pointer bg-white"
            >
              {t('export.sec3_cta_valuation')}
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
